import {
  CREATE_PERSON_ADDRESS_ERROR,
  CREATE_PERSON_ADDRESS_SUCCESS,
  CREATE_PERSON_BIRTHDAY_ERROR,
  CREATE_PERSON_BIRTHDAY_SUCCESS,
  CREATE_PERSON_COUNTRY_ERROR,
  CREATE_PERSON_COUNTRY_SUCCESS,
  CREATE_PERSON_NAME_ERROR,
  CREATE_PERSON_NAME_SUCCESS,
  CREATE_PERSON_SSN_ERROR,
  CREATE_PERSON_SSN_SUCCESS,
  UPDATE_PERSON_ADDRESS_ERROR,
  UPDATE_PERSON_ADDRESS_SUCCESS,
  UPDATE_PERSON_BIRTHDAY_ERROR,
  UPDATE_PERSON_BIRTHDAY_SUCCESS,
  UPDATE_PERSON_COUNTRY_ERROR,
  UPDATE_PERSON_COUNTRY_SUCCESS,
  UPDATE_PERSON_NAME_ERROR,
  UPDATE_PERSON_NAME_SUCCESS,
  UPDATE_PERSON_SSN_ERROR,
  UPDATE_PERSON_SSN_SUCCESS,
  CREATE_LEGAL_ENTITY_NAME_SUCCESS,
  CREATE_LEGAL_ENTITY_NAME_ERROR,
  UPDATE_LEGAL_ENTITY_NAME_SUCCESS,
  UPDATE_LEGAL_ENTITY_NAME_ERROR,
  CREATE_LEGAL_ENTITY_EIN_SUCCESS,
  CREATE_LEGAL_ENTITY_EIN_ERROR,
  UPDATE_LEGAL_ENTITY_EIN_SUCCESS,
  UPDATE_LEGAL_ENTITY_EIN_ERROR,
  CREATE_LEGAL_ENTITY_ADDRESS_SUCCESS,
  CREATE_LEGAL_ENTITY_ADDRESS_ERROR,
  UPDATE_LEGAL_ENTITY_ADDRESS_SUCCESS,
  UPDATE_LEGAL_ENTITY_ADDRESS_ERROR,
  CREATE_PERSON_MARTIAL_STATUS_SUCCESS,
  CREATE_PERSON_MARTIAL_STATUS_ERROR,
  UPDATE_PERSON_MARTIAL_STATUS_SUCCESS,
  UPDATE_PERSON_MARTIAL_STATUS_ERROR,
} from '../../actions/person/personActionConstants';
import createReducer from '../../utils/createReducer';

const initialState = {
  Person: {},
  LegalEntity: {},
  Error: '',
};

export default createReducer(
  {
    [CREATE_PERSON_NAME_SUCCESS]: createPerson,
    [CREATE_PERSON_NAME_ERROR]: createPersonError,
    [UPDATE_PERSON_NAME_SUCCESS]: createPerson,
    [UPDATE_PERSON_NAME_ERROR]: createPersonError,
    [CREATE_PERSON_SSN_SUCCESS]: createPerson,
    [CREATE_PERSON_SSN_ERROR]: createPersonError,
    [UPDATE_PERSON_SSN_SUCCESS]: createPerson,
    [UPDATE_PERSON_SSN_ERROR]: createPersonError,
    [CREATE_PERSON_ADDRESS_SUCCESS]: createPerson,
    [CREATE_PERSON_ADDRESS_ERROR]: createPersonError,
    [UPDATE_PERSON_ADDRESS_SUCCESS]: createPerson,
    [UPDATE_PERSON_ADDRESS_ERROR]: createPersonError,
    [CREATE_PERSON_BIRTHDAY_SUCCESS]: createPerson,
    [CREATE_PERSON_BIRTHDAY_ERROR]: createPersonError,
    [UPDATE_PERSON_BIRTHDAY_SUCCESS]: createPerson,
    [UPDATE_PERSON_BIRTHDAY_ERROR]: createPersonError,
    [CREATE_PERSON_COUNTRY_SUCCESS]: createPerson,
    [CREATE_PERSON_COUNTRY_ERROR]: createPersonError,
    [UPDATE_PERSON_COUNTRY_SUCCESS]: createPerson,
    [UPDATE_PERSON_COUNTRY_ERROR]: createPersonError,
    [CREATE_LEGAL_ENTITY_NAME_SUCCESS]: createLegalEntity,
    [CREATE_LEGAL_ENTITY_NAME_ERROR]: createLegalEntityError,
    [UPDATE_LEGAL_ENTITY_NAME_SUCCESS]: createLegalEntity,
    [UPDATE_LEGAL_ENTITY_NAME_ERROR]: createLegalEntityError,
    [CREATE_LEGAL_ENTITY_EIN_SUCCESS]: createLegalEntity,
    [CREATE_LEGAL_ENTITY_EIN_ERROR]: createLegalEntityError,
    [UPDATE_LEGAL_ENTITY_EIN_SUCCESS]: createLegalEntity,
    [UPDATE_LEGAL_ENTITY_EIN_ERROR]: createLegalEntityError,
    [CREATE_LEGAL_ENTITY_ADDRESS_SUCCESS]: createLegalEntity,
    [CREATE_LEGAL_ENTITY_ADDRESS_ERROR]: createLegalEntityError,
    [UPDATE_LEGAL_ENTITY_ADDRESS_SUCCESS]: createLegalEntity,
    [UPDATE_LEGAL_ENTITY_ADDRESS_ERROR]: createLegalEntityError,
    [CREATE_PERSON_MARTIAL_STATUS_SUCCESS]: createPerson,
    [CREATE_PERSON_MARTIAL_STATUS_ERROR]: createPersonError,
    [UPDATE_PERSON_MARTIAL_STATUS_SUCCESS]: createPerson,
    [UPDATE_PERSON_MARTIAL_STATUS_ERROR]: createPersonError,
  },
  initialState,
);

function createPerson(state, { payload }) {
  return {
    ...state,
    Person: {
      ...payload,
    },
    Error: '',
  };
}

function createPersonError(state, { payload }) {
  return {
    ...state,
    Error: payload,
  };
}

function createLegalEntity(state, { payload }) {
  return {
    ...state,
    LegalEntity: {
      ...payload,
    },
    Error: '',
  };
}

function createLegalEntityError(state, { payload }) {
  return {
    ...state,
    Error: payload,
  };
}
